import { useNavigate, useRouter } from '@tanstack/react-router'
import { Button } from 'antd'
import { FiAlertTriangle, FiHome, FiRefreshCw } from 'react-icons/fi'

import { ROUTES } from '@/core/constants/routes'

type TGlobalErrorProps = {
  error?: Error
}

const GlobalError = ({ error }: TGlobalErrorProps) => {
  const router = useRouter()
  const navigate = useNavigate()

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-linear-to-br from-amber-50 via-rose-50 to-orange-50 px-4 py-10">
      <div className="pointer-events-none absolute -top-32 -left-24 h-80 w-80 rounded-full bg-amber-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 -bottom-32 h-96 w-96 rounded-full bg-rose-200/50 blur-3xl" />

      <div className="relative w-full max-w-md rounded-3xl border border-white/60 bg-white/85 px-8 pt-10 pb-9 text-center shadow-[0_20px_60px_-15px_rgba(244,114,182,0.35)] backdrop-blur">
        <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-linear-to-br from-amber-400 to-rose-500 text-white shadow-lg shadow-rose-200">
          <FiAlertTriangle className="text-5xl" />
        </div>

        <h1 className="m-0 mb-2 text-2xl font-bold text-gray-900">
          Bir hata oluştu
        </h1>
        <p className="m-0 mb-7 text-sm leading-relaxed text-gray-600">
          Beklenmedik bir aksilik yaşandı. Endişelenme — tekrar denemek genelde
          işe yarar.
        </p>

        {error?.message && (
          <details
            data-testid="global-error-message"
            className="mb-7 rounded-xl border border-rose-100 bg-rose-50/70 px-4 py-3 text-left text-xs text-rose-900"
          >
            <summary className="cursor-pointer font-medium text-rose-700 select-none">
              Teknik detaylar
            </summary>
            <p className="mt-2 font-mono leading-relaxed wrap-break-word">
              {error.message}
            </p>
          </details>
        )}

        <div className="flex flex-col gap-2.5 sm:flex-row sm:justify-center">
          <Button
            type="primary"
            size="large"
            icon={<FiRefreshCw />}
            className="rounded-full! font-medium!"
            onClick={() => router.invalidate()}
          >
            Tekrar Dene
          </Button>
          <Button
            size="large"
            icon={<FiHome />}
            className="rounded-full! font-medium!"
            onClick={() => navigate({ to: ROUTES.app })}
          >
            Yönetime Dön
          </Button>
        </div>
      </div>
    </div>
  )
}

export default GlobalError
